//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { myAll, getList } from '@/api/yuangongquan'
import Scroll from '@/components/scroller'
import config from '@/config'
import { getUserAccount } from '@/api/user.js'
export default {
  components: { Scroll },
  data () {
    return {
      baseUrl: config.baseUrl,
      pageSize: 15,
      pageCurrent: 1,
      getUserAccountObj: {
        iconimgPATH: ''
      },
      obj: {},
      list: [],
      notFirstLoad: false,
      loadMoreDom: null,
      curUserid: this.$route.params.id
    }
  },
  computed: {
    userid () {
      return this.$store.state.user.userid
    }
  },
  mounted () {
    // 获取我的点赞和赠与总数
    // this.getInfo()
    this.getUserAccountInfo()
    // 获取内容
    this.getList()
    this.loadMoreDom = this.$el.querySelector('.load-more')
    this.listDom = this.$el.querySelector('.list-scroll')
  },
  methods: {
    getUserAccountInfo () {
      getUserAccount({
        userid: this.curUserid
      }).then(res => {
        this.getUserAccountObj = res.returnValue
      })
    },
    getInfo () {
      myAll({
        userid: this.curUserid
      }).then(res => {
        this.obj = res.obj
      })
    },
    getList (type, done) {
      getList({
        pageSize: this.pageSize,
        pageCurrent: this.pageCurrent,
        userid: this.curUserid
      })
        .then(res => {
          if (res.success) {
            if (type === 'refresh') {
              this.list = []
              this.listDom.scrollTop = 0
              this.loadMoreDom.style.display = 'flex'
            }
            let obj = res.obj
            if (obj.length === 0 && this.pageCurrent === 1) {
              this.list = []
              this.loadMoreDom.innerText = '暂无数据'
              this.loadMoreDom.style.display = 'flex'
            } else {
              let arr = obj.map((el, index) => {
                let istoday = this.isToday(el.createdate.slice(0, 10))
                let showdate = true
                if (
                  index > 0 &&
                  el.createdate.slice(0, 10) ===
                    obj[index - 1].createdate.slice(0, 10)
                ) {
                  showdate = false
                }
                let day = el.createdate.slice(8, 10)
                let month = el.createdate.slice(5, 7).replace(/^0+/, '')
                return {
                  istoday: istoday, // 是否是今天
                  showdate: showdate, // 是否显示日期（与上一条同一天）
                  day: day,
                  month: month,
                  ...el
                }
              })
              this.list =
                this.pageCurrent === 1 ? arr : [...this.list, ...arr]
              if (this.pageSize > res.obj.length) {
                this.loadMoreDom.style.display = 'none'
              } else {
                this.loadMoreDom.style.display = 'flex'
              }
            }
            done && done()
          }
        })
        .catch(() => {
          this.notFirstLoad = true
          done && done()
        })
    },
    isToday (str) {
      let date = new Date()
      let y = date.getFullYear() // 年
      let m = date.getMonth() + 1 // 月份从0开始的
      let d = date.getDate() // 日
      m = m < 10 ? '0' + m : m
      d = d < 10 ? '0' + d : d
      return str === y + '-' + m + '-' + d
    },
    gotoAdd () {
      this.$router.push({
        name: 'yuangongquanAddMoments'
      })
    },
    // 下拉刷新
    refresh (done) {
      this.pageCurrent = 1
      this.loadMoreDom.innerText = '加载中...'
      this.getList('refresh', done)
    },
    // 上拉加载更多
    loadMore (done) {
      this.pageCurrent++
      this.loadMoreDom.innerText = '加载中...'
      this.getList('more', done)
    },
    detail (id) {
      this.$router.push({ name: 'yuangongquanDetail', params: { id: id } })
    }
  }
}
